import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { AuthStore } from '../store';
import { map } from 'rxjs';
import { AUTH_ROUTES_PATHS } from '@app/auth/auth.routes.model';

export const authenticatedGuard: CanMatchFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (!authStore.token()) {
    return new RedirectCommand(router.parseUrl(AUTH_ROUTES_PATHS.LOGIN));
  }

  return !!authStore.currentUser() || authStore.loadCurrUser().pipe(map(() => true));
};
